'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const FEATURES_URL = 'https://edge.unrevealed.tech';
const TRACKING_URL = 'https://track.unrevealed.tech';

const UnrevealedContext = React.createContext({
    clientKey: '',
    allFeatures: new Set(),
    activeFeatures: new Set(),
    loading: true,
    error: null,
    filteredFeatures: new Set(),
    setFilteredFeatures: () => [],
    trackingUrl: TRACKING_URL,
    setUser: () => { },
    setTeam: () => { },
    defaults: {},
    fetchIndex: 0,
    setFetchIndex: () => { },
});

function FeatureList() {
    const { allFeatures, filteredFeatures, setFilteredFeatures } = React.useContext(UnrevealedContext);
    const features = [...allFeatures].sort((a, b) => (a > b ? 1 : -1));
    const handleChange = (feature) => (event) => {
        if (event.currentTarget.checked) {
            setFilteredFeatures(new Set([...filteredFeatures].filter((f) => feature !== f)));
        }
        else {
            setFilteredFeatures(new Set([...filteredFeatures, feature]));
        }
    };
    return (React__default["default"].createElement("div", { className: "unrevealed-react-list-wrapper" },
        React__default["default"].createElement("ul", { className: "unrevealed-react-list" }, features.map((feature) => {
            const id = `unrevealed-switch-${feature}`;
            return (React__default["default"].createElement("li", { key: feature, className: "unrevealed-react-list-item" },
                React__default["default"].createElement("input", { type: "checkbox", name: feature, id: id, checked: !filteredFeatures.has(feature), onChange: handleChange(feature) }),
                React__default["default"].createElement("label", { htmlFor: id }, feature)));
        }))));
}

var styles = ".unrevealed-react-wrapper {\n  position: fixed;\n  z-index: 10000;\n  bottom: 32px;\n  right: 32px;\n  color: #228be6;\n  display: flex;\n  align-items: flex-end;\n  column-gap: 12px;\n}\n\n.unrevealed-react-button {\n  all: initial;\n  background: white;\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.unrevealed-react-button:hover,\n.unrevealed-react-button.unrevealed-react-button__active {\n  background: #e7f5ff;\n}\n\n.unrevealed-react-list-wrapper {\n  padding: 6px;\n  background: #e7f5ff;\n  border-radius: 5px;\n}\n\n.unrevealed-react-list {\n  list-style: none;\n  padding: 12px;\n  margin: 0;\n}\n\n.unrevealed-react-list-item {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.unrevealed-react-list-item:hover {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n";

function FeatureToggler() {
    const [isVisible, setIsVisible] = React.useState(false);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("style", null, styles),
        React__default["default"].createElement("div", { className: "unrevealed-react-wrapper" },
            isVisible && React__default["default"].createElement(FeatureList, null),
            React__default["default"].createElement("button", { className: `unrevealed-react-button ${isVisible ? 'unrevealed-react-button__active' : ''}`, onClick: () => setIsVisible((prev) => !prev) },
                React__default["default"].createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: "icon icon-tabler icon-tabler-toggle-right", width: "20", height: "20", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "#228be6", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" },
                    React__default["default"].createElement("path", { stroke: "none", d: "M0 0h24v24H0z", fill: "none" }),
                    React__default["default"].createElement("circle", { cx: "16", cy: "12", r: "2" }),
                    React__default["default"].createElement("rect", { x: "2", y: "6", width: "20", height: "12", rx: "6" }))))));
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

const CACHE_KEY = 'unrevealed:features';
function getCachedFeatures(cachePolicy) {
    var _a;
    if (cachePolicy === 'none') {
        return [];
    }
    if (cachePolicy === 'localStorage') {
        try {
            const features = JSON.parse((_a = localStorage.getItem(CACHE_KEY)) !== null && _a !== void 0 ? _a : '[]');
            if (isCacheValid(features)) {
                return features;
            }
            return [];
        }
        catch (err) {
            return [];
        }
    }
    return [];
}
function setCachedFeatures(features, cachePolicy) {
    if (cachePolicy === 'localStorage') {
        try {
            localStorage.setItem(CACHE_KEY, JSON.stringify(features));
        }
        catch (err) {
            return;
        }
    }
}
function isCacheValid(cachedFeatures) {
    return (Array.isArray(cachedFeatures) &&
        cachedFeatures.every((feature) => typeof feature === 'string'));
}

function serializeBody(body) {
    try {
        return JSON.stringify(body);
    }
    catch (_a) {
        return null;
    }
}

function useFetchFeatures({ clientKey, user, team, cachePolicy, fetchIndex = 0, }) {
    const [features, setFeatures] = React.useState(new Set());
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const cacheLoaded = React.useRef(false);
    React.useEffect(() => {
        let isCancelled = false;
        setLoading(true);
        if (!cacheLoaded.current) {
            const cachedFeatures = getCachedFeatures(cachePolicy);
            if (cachedFeatures.length > 0) {
                setFeatures(new Set(cachedFeatures));
            }
            cacheLoaded.current = true;
        }
        fetch(FEATURES_URL, {
            method: 'post',
            headers: { 'Client-Key': clientKey },
            body: serializeBody({ user, team }),
        })
            .then((response) => response.json())
            .then((data) => {
            if (!isCancelled) {
                setFeatures(new Set(data.features));
                setCachedFeatures(data.features, cachePolicy);
            }
        })
            .catch((err) => {
            if (!isCancelled) {
                setError(err.message);
            }
        })
            .finally(() => {
            if (!isCancelled) {
                setLoading(false);
            }
        });
        return () => {
            isCancelled = true;
        };
    }, [user, team, clientKey, fetchIndex]);
    return {
        loading,
        error,
        features,
    };
}

function UnrevealedProvider(_a) {
    var { clientKey, children, cachePolicy = 'none', defaults = {} } = _a, props = __rest(_a, ["clientKey", "children", "cachePolicy", "defaults"]);
    const { trackingUrl } = props;
    const [filteredFeatures, setFilteredFeatures] = React.useState(new Set());
    const [user, setUser] = React.useState(null);
    const [team, setTeam] = React.useState(null);
    const [fetchIndex, setFetchIndex] = React.useState(0);
    const { features: allFeatures, loading, error, } = useFetchFeatures({
        clientKey,
        user,
        team,
        cachePolicy,
        fetchIndex,
    });
    const activeFeatures = React.useMemo(() => {
        if (filteredFeatures.size === 0) {
            return allFeatures;
        }
        return new Set([...allFeatures].filter((feature) => !filteredFeatures.has(feature)));
    }, [filteredFeatures, allFeatures]);
    return (React__default["default"].createElement(UnrevealedContext.Provider, { value: {
            clientKey,
            allFeatures,
            activeFeatures,
            loading,
            error,
            filteredFeatures,
            setFilteredFeatures,
            trackingUrl: trackingUrl || TRACKING_URL,
            setUser,
            setTeam,
            defaults,
            fetchIndex,
            setFetchIndex,
        } }, children));
}

function useFeature(featureKey) {
    const { error, loading, activeFeatures, defaults } = React.useContext(UnrevealedContext);
    const enabled = activeFeatures.has(featureKey) ||
        (loading && defaults[featureKey] === true);
    const isFeatureLoading = loading && defaults[featureKey] !== undefined;
    return {
        loading: isFeatureLoading,
        enabled,
        error,
    };
}

function useFeatures() {
    const { allFeatures: allFeatureKeys, filteredFeatures, setFilteredFeatures, } = React.useContext(UnrevealedContext);
    const allFeatures = React.useMemo(() => [...allFeatureKeys].map((feature) => ({
        key: feature,
        enabled: !filteredFeatures.has(feature),
    })), [allFeatureKeys, filteredFeatures]);
    const activeFeatures = React.useMemo(() => allFeatures.filter(({ enabled }) => enabled).map(({ key }) => key), [allFeatures]);
    const toggleFeature = React.useCallback((feature) => {
        if (filteredFeatures.has(feature)) {
            setFilteredFeatures((prev) => new Set([...prev].filter((f) => feature !== f)));
        }
        else {
            setFilteredFeatures((prev) => new Set([...prev, feature]));
        }
    }, [filteredFeatures, setFilteredFeatures]);
    return {
        allFeatures,
        activeFeatures,
        toggleFeature,
    };
}

function useIdentify() {
    const { setTeam, setUser, trackingUrl, clientKey } = React.useContext(UnrevealedContext);
    const track = (type, body) => __awaiter(this, void 0, void 0, function* () {
        try {
            yield fetch(`${trackingUrl}/identify-${type}`, {
                method: 'post',
                headers: {
                    'Client-Key': clientKey,
                    'Content-Type': 'application/json',
                },
                body: serializeBody(body),
            });
        }
        catch (err) {
            console.error(err);
        }
    });
    const identify = React.useCallback(({ user, team }) => __awaiter(this, void 0, void 0, function* () {
        setUser(user);
        setTeam(team !== null && team !== void 0 ? team : null);
        if (user) {
            yield track('user', { userId: user.id, traits: user.traits });
        }
        if (team) {
            yield track('team', {
                teamId: team.id,
                userId: user === null || user === void 0 ? void 0 : user.id,
                traits: team.traits,
            });
        }
    }), []);
    return { identify };
}

function useReload() {
    const { setFetchIndex } = React.useContext(UnrevealedContext);
    const reload = React.useCallback(() => {
        setFetchIndex((prev) => prev + 1);
    }, []);
    return { reload };
}

exports.FeatureToggler = FeatureToggler;
exports.UnrevealedProvider = UnrevealedProvider;
exports.useFeature = useFeature;
exports.useFeatures = useFeatures;
exports.useIdentify = useIdentify;
exports.useReload = useReload;
//# sourceMappingURL=main.js.map
